import { CSSProperties, ForwardedRef, ReactNode, forwardRef } from 'react'
import { default as NextLink } from 'next/link'

import { AppLanguage } from '~/types/locale'

interface LinkProps {
  as?: string
  children?: ReactNode
  className?: string
  disabled?: boolean
  onClick?: (...args: unknown[]) => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  openInNewTab?: boolean
  style?: CSSProperties
  to: string | { pathname: string; query: Record<string, undefined | string | string[]> }
  prefetch?: boolean
  shallow?: boolean
  rel?: string
  role?: string
  target?: '_blank' | '_self' | '_parent' | '_top'
  locale?: AppLanguage | false
  scroll?: boolean
  replace?: boolean
}

function LinkComponent(
  {
    as,
    children,
    disabled,
    openInNewTab,
    to,
    prefetch,
    shallow = false,
    scroll = true,
    replace = false,
    locale,
    ...rest
  }: LinkProps,
  ref: ForwardedRef<HTMLAnchorElement>,
): React.ReactElement {
  const href = disabled ? '#' : to
  const newTabAttrs = openInNewTab ? { target: '_blank', rel: 'noopener noreferrer' } : undefined

  return (
    <NextLink
      as={as}
      href={href}
      locale={locale}
      passHref
      ref={ref}
      replace={replace}
      scroll={scroll}
      shallow={shallow}
      {...rest}
      {...newTabAttrs}
    >
      {children}
    </NextLink>
  )
}

export const Link = forwardRef(LinkComponent)
